<template>
  <tr>
    <td>{{ contract.id | nullable }}</td>
    <td>{{ contract.name | nullable }}</td>
    <td>{{ contract.description | sentenceCase | nullable }}</td>
    <td>{{ contract.reset_date | sentenceCase | nullable }}</td>
    <td>{{ contract.requirement_value | nullable }}</td>
    <td>{{ contract.requirement_name_nice_name | sentenceCase | nullable }}</td>
    <td>{{ admins | parseArray | nullable }}</td>
    <td>
      <button class="edit-button" @click="$emit('edit', contract.id)">
        <i class="fa fa-fw fa-pencil-square-o" />
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    contract: {
      required: true,
      type: Object
    }
  },

  filters: {
    parseArray: function (value) {
      if (Array.isArray(value)) {
        return value.join(', ')
      }
      return value
    }
  },

  computed: {
    admins () {
      if (!this.contract.admins || !this.contract.admins.length) {
        return null
      }
      return this.contract.admins.map(item => item.name)
    }
  }
}
</script>
